import { Node } from 'tiptap';
import { ENodeAlign } from '@/editor/types/enums';

export default class ParagraphNode extends Node {
  get name() {
    return 'paragraph';
  }

  get schema() {
    return {
      content: 'inline*',
      group: 'block',
      attrs: {
        align: {
          default: ENodeAlign.Left,
        },
      },
      draggable: false,
      parseDOM: [
        {
          tag: 'p',
          getAttrs: node => ({
            align: node.getAttribute('class'),
          }),
        },
      ],
      toDOM: node => ['p', { class: node.attrs.align }, 0],
    };
  }
}
